// @flow
import { createContext } from 'react';
import type { Context } from 'react';

type HamburgerContextType = {
  onToggle: Function,
};

export const HamburgerContext: Context<HamburgerContextType> = createContext({
  onToggle: () => {},
});
